<template>
    <v-container fluid>
        <v-card class="elevation-3" :loading="loading">
            <div class="card-title">{{ $t('EmailTemplates') }}</div>
            <v-card-text>
                <v-card-title>
                    <v-text-field v-model="search" class="me-8" append-icon="mdi-magnify" :label="$t('Search')" single-line hide-details />

                    <v-spacer />

                </v-card-title>
                <v-data-table :headers="headers" dense :items="templates" :search="search" class="mt-6">
                    <template v-slot:[`item.name`]="{ item }">
                        {{ item.name }}
                    </template>
                    <template v-slot:[`item.subject`]="{ item }">
                        {{ item.subject }}
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <table>
                            <tr>

                                <td style="padding:10px">
                                    <router-link class="mx-3" :to="{ name: 'edit-template', query: { id: item.id }}">
                                        <v-icon color="primary" role="link">mdi-pencil</v-icon>
                                    </router-link>
                                </td>
                            </tr>
                        </table>
                    </template>

                    <template v-slot:[`item.options`]="{ item }">
                        <router-link class="mx-3" :to="{ name: 'edit-template', query: { id: item.id }}">
                            <v-icon color="primary" role="link">mdi-pencil</v-icon>
                        </router-link>
                    </template>


                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script lang="ts">
    import { mapGetters } from 'vuex'
    import EmailTemplatesService from '@/services/EmailTemplatesService.js'

    export default {
       
        data() {
            return {
                search: '',
                selectedTemplateId: 0,
                loading: false,
                enabled: false,
                templates: [],
                mainSurveyList: [],
                userPermissionsList: [],

                headers: [
                    { text: this.$t('Id'), value: 'id' },
                    { text: this.$t('AppCode'), value: 'appCode', width: '15%', },
                    { text: this.$t('Name'), value: 'name', width: '15%', },
                    { text: this.$t('Subject'), value: 'subject', width: '15%', },
                    { text: this.$t('Actions'), value: 'actions' }

                ],
                selectedItem: null,
                selectedTitle: ''

            }
        },

        created() {
            this.listTemplates()
        },
        mounted() {
        },
        computed: {
            ...mapGetters('user', ['language']),
            getLanguage() {
                return this.language == null ? 'ar' : this.language

            },
            
        },
        methods: {
            handleAction(action, item) {
                switch (action.action) {
                    case 'edit':
                        this.editTemplate(item.id)
                        break
                    
                    default:
                        break
                }
            },
            editTemplate(id) {
                this.$router.push({ name: 'edit-template', query: { id } })
            },
            
            listTemplates() {
                this.loading = true
                EmailTemplatesService.listTemplates().then((res) => {
                    this.templates = res.data
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },


        }
    }
</script>

<style scoped>
    .v-chip.draft {
        background: #dedede;
    }

    .v-chip.pending {
        background: #ffaa2c;
    }

    .v-chip.approved {
        background: var(--v-secondary-base);
        color: #fff
    }
</style>